import api from '@/utils/api'
import { constructFilter } from '@/utils/servicesUtil'

export default {
    getAllViberCampaigns(filters) {
        return api.get(`viber-campaigns${constructFilter(filters)}`)
    },
    duplicateViberCampaign(id) {
        return api.post(`viber-campaigns/${id}/duplicate`)
    },
    createViberCampaign(campaign) {
        return api.post('viber-campaigns', campaign)
    },
    updateViberCampaign(campaign) {
        return api.put(`viber-campaigns/${campaign.id}`, campaign)
    },
    uploadViberCampaignFile(id, data) {
        return api.post(`viber-campaigns/${id}/import-file`, data)
    },
    submitViberCampaign(id) {
        return api.put(`viber-campaigns/${id}/submit`)
    },
    getViberCampaignById(id) {
        return api.get(`viber-campaigns/${id}`)
    },
    getViberCampaignProgress(id) {
        return api.get(`viber-campaigns/${id}/progress`)
    },
    getViberCampaignStatusMessages(id) {
        return api.get(`viber-campaigns/${id}/status-count/messages`)
    },
    getViberCampaignStatusFallback(id) {
        return api.get(`viber-campaigns/${id}/status-count/fallbacks`)
    },
    getViberMessages(id, filters, isPreview) {
        return api.get(`viber-campaigns/${id}/messages${constructFilter(filters, isPreview)}`)
    },
    getViberFallbacks(id, filters, isPreview) {
        return api.get(`viber-campaigns/${id}/fallbacks${constructFilter(filters, isPreview)}`)
    },
    getViberCampaignReports(id, isFallback) {
        return api.get(`viber-campaigns/${id}/export/${isFallback}`)
    },
    updateViberCampaignStatus(id, status) {
        return api.put(`viber-campaigns/${id}/pause/${status}`)
    },
    downloadUploadedFile(id) {
        return api.get(`downloads/viber-campaigns/${id}`)
    },
    sentTestViberCampaign(id, testListId) {
        return api.post(`viber-campaigns/${id}/send-test/list-id/${testListId}`)
    },
    deleteViberCampaign(id) {
        return api.delete(`viber-campaigns/${id}`)
    }
}
